export let TimelineGridCurrentTimeIndicatorCssVars = /*#__PURE__*/function (TimelineGridCurrentTimeIndicatorCssVars) {
  TimelineGridCurrentTimeIndicatorCssVars["xPosition"] = "--x-position";
  return TimelineGridCurrentTimeIndicatorCssVars;
}({});